"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AclGuard = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const acl_service_1 = require("./acl.service");
const constants_1 = require("./constants");
let AclGuard = class AclGuard {
    constructor(aclService) {
        this.aclService = aclService;
    }
    async canActivate(context) {
        const request = context.switchToHttp().getRequest();
        // By passing the login and register endpoints
        const serviceName = request.params.service;
        const path = request.path.replace(`/${constants_1.iirm}/${serviceName}`, "");
        const subPath = path.split("/").filter(Boolean)[0];
        if (constants_1.bypassAclGuardApis.includes(path) ||
            path.includes("employee/password-reset-mail") ||
            path.includes("look-up")) {
            return true;
        }
        if (subPath === "knowledge" || subPath === "localization")
            return true; // TODO: remove this line when ACL is mapped in DB for knowledge service
        const user = request.user;
        // return unauthorized if roleId is not present
        if (!user || !user?.userDetails?.roles) {
            throw new common_1.UnauthorizedException("Missing user role");
        }
        const method = request.method;
        const roleIds = user?.userDetails?.roles.map((role) => role.id);
        const hasAccess = await this.aclService.hasAccess(roleIds, method, subPath);
        if (!hasAccess) {
            throw new common_1.UnauthorizedException("Access denied");
        }
        return true;
    }
};
exports.AclGuard = AclGuard;
exports.AclGuard = AclGuard = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof acl_service_1.AclService !== "undefined" && acl_service_1.AclService) === "function" ? _a : Object])
], AclGuard);
